export const generateFallbackColor = (url: string): string => {
  let hash = 0;
  for (const character of url) {
    // `!` вместо `?? 0` (AF-351): `for...of` по строке отдаёт кодовые точки, то
    // есть непустые строки, а `codePointAt(0)` возвращает undefined только для
    // индекса за пределами строки. Ветка `?? 0` была недостижима и держалась
    // директивой `v8 ignore`.
    hash = (character.codePointAt(0) as number) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, 45%, 35%)`;
};
